<app-toast />
<p-confirmDialog [style]="{ width: '26rem' }"></p-confirmDialog>
<section class="dashboard-comissoes">
    @if (tipo === 'atividades') {
        <app-dashboard-atividades-comissoes></app-dashboard-atividades-comissoes>
    } @else {
        @if (!telaAtaVisivel) {
            <div class="layout-dashboard" [class.sem-filtros]="!filtrosVisiveis()">
                @if (filtrosVisiveis()) {
                    <aside class="coluna-filtros">
                        <app-filtros-comissoes
                            [filtros]="filtrosAtivos"
                            [opcoesLocais]="opcoesLocais"
                            [opcoesAssistentes]="opcoesAssistentes"
                            [opcoesStatusAta]="opcoesStatusAta"
                            [tiposComissao]="tiposComissao"
                            [estruturasComissao]="estruturasComissao"
                            [carregandoEstruturasComissao]="carregandoEstruturasComissao"
                            [erroEstruturasComissao]="erroEstruturasComissao"
                            (carregarEstruturasComissao)="aoCarregarEstruturasComissao()"
                            (aplicarFiltros)="aoAplicarFiltros($event)"
                            (limparFiltros)="aoLimparFiltros()"
                        ></app-filtros-comissoes>
                    </aside>
                }

                <section class="coluna-conteudo">
                    <app-tabela-reunioes-comissoes
                        [reunioes]="reunioesFiltradas"
                        [totalRegistros]="totalRegistrosReunioes"
                        [first]="primeiraLinhaReunioes"
                        [rows]="linhasPorPaginaReunioes"
                        [reuniaoSelecionada]="reuniaoSelecionada"
                        [carregando]="carregandoReunioes"
                        [dashboardSummary]="dashboardSummary"
                        [itensOpcoes]="itensAcoes()"
                        [filtrosVisiveis]="filtrosVisiveis()"
                        (selecionarReuniao)="aoSelecionarReuniao($event)"
                        (acaoTabela)="aoExecutarAcaoTabela($event)"
                        (paginaAlterada)="aoMudarPaginaReunioes($event)"
                        (alternarFiltros)="alternarFiltros()"
                    ></app-tabela-reunioes-comissoes>
                </section>
            </div>

            <app-gerenciar-convocacoes [(visivel)]="gerenciarConvocacoesVisivel" [reuniao]="reuniaoSelecionada" (atualizado)="aoAtualizarConvocacoes()"></app-gerenciar-convocacoes>
        } @else {
            <app-ata-reuniao
                [reuniao]="reuniaoSelecionada"
                [opcoesAssistentes]="opcoesAssistentes"
                [documentoAtaHtml]="documentoAtaHtml"
                [textoInicioAtaModelo]="textoInicioAtaModelo"
                [gatilhoInsercaoInicioAta]="gatilhoInsercaoInicioAta"
                [textoFinalizacaoAtaModelo]="textoFinalizacaoAtaModelo"
                [gatilhoInsercaoFinalizacaoAta]="gatilhoInsercaoFinalizacaoAta"
                [membros]="membrosAta"
                [convidados]="convidadosAta"
                [atividades]="atividadesAta"
                [situacoesAtividade]="situacoesAtividade"
                [modelosAta]="modelosAta"
                [autosaveIntervaloSegundos]="autosaveIntervaloSegundos"
                [autosavePausado]="autosavePausadoAta"
                [conflitoAtaMensagem]="conflitoAtaMensagem"
                (recarregarAtaSolicitado)="aoRecarregarAta()"
                (solicitarInicioAta)="aoSolicitarInicioAta()"
                (solicitarFinalizacaoAta)="aoSolicitarFinalizacaoAta()"
                (salvar)="aoSalvarAta($event)"
                (autosave)="aoAutosaveAta($event)"
                (modeloSelecionado)="aoInserirModeloAta($event)"
                (baixarDocumento)="aoBaixarDocumentoAta()"
                (editarReuniao)="aoEditarReuniaoDaAta()"
                (gestoresAlterados)="aoAlterarGestoresAta($event)"
                (assistenteAlterado)="aoAlterarAssistenteAta($event)"
                (participanteAlterado)="aoAlterarParticipanteAta($event)"
                (convidadoAdicionado)="aoAdicionarConvidadoAta($event)"
                (convidadoRemovido)="aoRemoverConvidadoAta($event)"
                (atividadeSalva)="aoSalvarAtividadeAta($event)"
                (atividadeExcluida)="aoExcluirAtividadeAta($event)"
                (atividadeResolvidaAlterada)="aoAlterarAtividadeResolvidaAta($event)"
                (voltar)="aoVoltarDaAta()"
            ></app-ata-reuniao>
        }

        <app-formulario-reuniao-comissoes
            [(visivel)]="formularioReuniaoVisivel"
            [reuniao]="reuniaoFormulario"
            [locais]="locaisReuniao"
            [tiposComissao]="tiposComissao"
            [estruturasComissao]="estruturasComissao"
            [carregandoEstruturas]="carregandoEstruturasComissao"
            (carregarEstruturas)="aoCarregarEstruturasComissao()"
            (salvar)="aoSalvarFormularioReuniao($event)"
        ></app-formulario-reuniao-comissoes>
    }
</section>
